import React, { useEffect, useState } from "react";
import Select from "react-select";

const BusinessHours = ({ minHoursDropdown, workingHours, onChange, businessListDisable }) => {
  // Initialize state with existing working hours OR default values
  const [businessHours, setBusinessHours] = useState([]);

  useEffect(() => {
    if (workingHours && workingHours.length > 0) {
      setBusinessHours(workingHours); // Load existing hours if provided
    }
  }, [workingHours]);

  // Handle time change and notify parent
  const handleChange = (dayId, field, value) => {
    const updatedHours = businessHours.map((item) =>
      item.dayId === dayId ? { ...item, [field]: value } : item
    );
    setBusinessHours(updatedHours);
    if (typeof onChange === "function") {
      onChange(updatedHours); // Notify parent about the update
    }
  };

  // Toggle Day Off Status
  const toggleDayOff = (dayId) => {
    const updatedHours = businessHours.map((item) =>
      item.dayId === dayId
        ? {
            ...item,
            isDayOff: item.isDayOff ? 0 : 1,
          }
        : item
    );

    setBusinessHours(updatedHours);
    if (typeof onChange === "function") {
      onChange(updatedHours);
    }
  };

  const safeDropdownOptions = Array.isArray(minHoursDropdown) ? minHoursDropdown : [];

  return (
    <div className="row">
      {businessHours?.map((day) => (
        <div key={day.dayId} className="mb-3 col-12">
          <label className="fw-bold primary-color mb-1">{day.dayName}</label>
          <div className="row align-items-center g-2">
            {/* Toggle Day Off Checkbox */}
            <div className="col-12 col-sm-12 col-md-3 col-lg-3 d-flex align-items-center gap-2 mb-2 mb-md-0">
              <input
                type="checkbox"
                checked={day.isDayOff === 1}
                onChange={() => toggleDayOff(day.dayId)}
                disabled={businessListDisable} // Disable checkbox
                className="custome-boder form-check-input mt-0"
              />
              <label className="text-color-70 fw-bold mb-0">Day Off</label>
            </div>

            {/* Opening Time Selector */}
            <div className="col-12 col-sm-6 col-md-4 col-lg-4 mb-2 mb-md-0">
              <label className="fw-bold text-color-70 mb-1 small">Opening Time</label>
              <Select
                classNamePrefix="react-select"
                options={safeDropdownOptions}
                name="startTime"
                value={safeDropdownOptions.find((el) => el?.timeValue === day.startTime) || null}
                onChange={(e) => handleChange(day.dayId, "startTime", e?.timeValue)}
                placeholder="Opening Time"
                isDisabled={day.isDayOff === 1 || businessListDisable}
              />
            </div>

            {/* Closing Time Selector */}
            <div className="col-12 col-sm-6 col-md-4 col-lg-4">
              <label className="fw-bold text-color-70 mb-1 small">Closing Time</label>
              <Select
                classNamePrefix="react-select"
                options={safeDropdownOptions}
                name="endTime"
                value={safeDropdownOptions.find((el) => el?.timeValue === day.endTime) || null}
                onChange={(e) => handleChange(day.dayId, "endTime", e?.timeValue)}
                placeholder="Closing Time"
                isDisabled={day.isDayOff === 1 || businessListDisable}
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default BusinessHours;
